import React, { useEffect, useState } from "react";
import { Box, Typography, Button, TextField, Card, CardContent, Collapse, IconButton, CircularProgress } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { useNavigate } from "react-router-dom";
import Cong1 from "../../../assets/cong1.png";
import Coins from "../../../assets/coins.png";
import Gift from "../../../assets/Gift.png";
import DiscountTag from "../../../assets/DiscountTag.png";
import CoinsGray from "../../../assets/coinsGray.png";
import GiftGray from "../../../assets/Giftgray.png";
import DiscountTagGray from "../../../assets/DiscountTagGray.png";
/* import { mpCoupon } from "../../Mixpanel"; */
/* import WaitingLoader from "../WaitingLoader/component"; */
import couponicon from '../../../assets/couponicon.png'
import AutoApplyPopup from "../Popup/AutoApplyPopup";
import CouponDialog from "../Popup/CouponPopup";

const CouponsList = ({couponsList,setShowCoupoListFlag,CouponText ,showCouponPopFlag ,handleCloseCouponPopup, couponAppliedSuccess,ApplyCoupon}) => {
  const navigate = useNavigate();
  const [expandedIndex, setExpandedIndex] = useState(null);
const [typedCouponName,setTypedCouponName]=useState(null)
  useEffect(() => {
    if (localStorage.getItem("Guest_clientId")) {
      navigate("/myCart");
    }
    /* mpCoupon({ data: "Coupon Page Open" }); */
  }, []);

  const appliedCouponName = localStorage.getItem("appliedCouponName");
  const applicableCoupons = couponsList?.filter((c) => c.isApplicable);
  const notApplicableCoupons = couponsList?.filter((c) => !c.isApplicable);

  const toggleExpand = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  const handleClose = () => setShowCoupoListFlag(false);

const TypeCouponName=(e)=>{
setTypedCouponName(e.target.value)
}

const handleApplyCoupon=(e)=>{
    ApplyCoupon(typedCouponName)
    //setTypedCouponName("")
}

  return (
    <>
{showCouponPopFlag&&<CouponDialog  CouponText={CouponText}
            handleCloseCouponPopup={handleCloseCouponPopup}
            couponAppliedSuccess={couponAppliedSuccess}/>}
    <Box
      sx={{
        position: "absolute",
        zIndex: 9999,
        bgcolor: "white",
        height: "100vh",
        width: "100%",
        overflowY: "auto",
    
        background: "linear-gradient(180deg, #EAF7FF 0%, #FDF7F5 100%)",
             
            
      }}
    >
      {/* {loader && <WaitingLoader />} */}

      {/* Congrats Modal */}


      {/* Header */}
      <Box display="flex" alignItems="center" p={2} style={{background:"#fae14b"}}>
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
        <Typography variant="h6" sx={{ fontWeight: 500, ml: 1 }}>
          Apply Coupon
        </Typography>
      </Box>

      {/* Coupon input */}

            <Card
        elevation={3}
        sx={{
          mt: 3,
          mx: 2,
          borderRadius: 3,
        }}
      >
        <CardContent sx={{ display: "flex", alignItems: "center", gap: 1, }} style={{paddingBottom:"16px"}}>
         <img src={couponicon} style={{width:"20px"}}/>

          <TextField
            variant="standard"
            placeholder="Enter coupon code"
            fullWidth
             onChange={(e) =>TypeCouponName(e)}
            InputProps={{
              disableUnderline: true,
              sx: { fontSize: "16px" },
            }}
          />

          <Button
            variant="text"
            sx={{ fontWeight: 600, color: "#00B177" }}
             onClick={(e) =>handleApplyCoupon(e)}
              disabled={!typedCouponName || typedCouponName.length < 3}
          >
            APPLY
          </Button>
        </CardContent>
      </Card>
<Box>
{applicableCoupons||applicableCoupons?
<Box>
         
      {/* Applicable Coupons */}
      {applicableCoupons?.length > 0 && (
        <Box px={3} mt={3}>
          <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
            Applicable Coupons
          </Typography>
        </Box>
      )}
      <Box px={2} pb={3}>
        {applicableCoupons?.map((el, index) => (
          <Card
            key={index}
            sx={{
              my: 2,
              borderRadius: 2,
              position: "relative",
              background: "linear-gradient(135deg, #e74c3c, #c0392b)",
              color: "white",
              overflow: "hidden",
            }}
          >
            <CardContent>
              <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                {el.couponName}
              </Typography>
              <Typography variant="body2">{el.couponDescription}</Typography>
              <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
                <Button
                  color="inherit"
                  endIcon={expandedIndex === index ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                  onClick={() => toggleExpand(index)}
                  sx={{ color: "white" }}
                >
                  More
                </Button>
                <Button
                  variant="contained"
                  onClick={(e) => ApplyCoupon(el.couponName)}
                  sx={{
                    background: "black",
                    color: "white",
                    borderRadius: 5,
                    px: 3,
                    "&:hover": { background: "#222" },
                  }}
                >
                  Apply
                </Button>
              </Box>
              <Collapse in={expandedIndex === index} timeout="auto" unmountOnExit>
                <Typography variant="body2" sx={{ mt: 2, color: "white", opacity: 0.9 }}>
                  {el.tnc}
                </Typography>
              </Collapse>
            </CardContent>
            {/* Coupon Type Icon */}
            <Box
              component="img"
              src={el.couponType === 1 ? Coins : el.couponType === 2 ? Gift : DiscountTag}
              alt=""
              sx={{ position: "absolute", right: 16, top: 16, width: 70, opacity: 0.8 }}
            />
          </Card>
        ))}
      </Box>

      {/* Not Applicable Coupons */}
      {notApplicableCoupons?.length > 0 && (
        <Box px={3} mt={2}>
          <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
           Unavailable Coupons
          </Typography>
        </Box>
      )}
      <Box px={2} pb={5}>
        {notApplicableCoupons?.map((el, index) => (
          <Card
            key={index}
            sx={{
              my: 2,
              borderRadius: 2,
              backgroundColor: "#EEE",
              position: "relative",
            }}
          >
            <CardContent>
              <Typography variant="h6" sx={{ color: "rgba(72,72,72,0.67)" }}>
                {el.couponName}
              </Typography>
              <Typography variant="body2" sx={{ fontWeight: 500, color: "rgba(0,0,0,0.9)" }}>
                {el.couponDescription}
              </Typography>
              <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
                <Button
                  endIcon={expandedIndex === index ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                  onClick={() => toggleExpand(index)}
                  sx={{ color: "rgba(56,79,111,1)" }}
                >
                  More
                </Button>
                {el.reason && (
                  <Typography variant="caption" sx={{ color: "rgba(255,0,0,0.84)" }}>
                    {el.reason}
                  </Typography>
                )}
              </Box>
              <Collapse in={expandedIndex === index} timeout="auto" unmountOnExit>
                <Typography variant="body2" sx={{ mt: 2, color: "rgba(114,114,114,1)" }}>
                  {el.tnc}
                </Typography>
              </Collapse>
            </CardContent>
            <Box
              component="img"
              src={
                el.couponType === 1
                  ? CoinsGray
                  : el.couponType === 2
                  ? GiftGray
                  : DiscountTagGray
              }
              alt=""
              sx={{ position: "absolute", right: 16, top: 16, width: 70, opacity: 0.6 }}
            />
          </Card>
        ))}
      </Box>
  
    </Box>:  <Box
        sx={{
          mt: 10,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          opacity: 0.7,
        }}
      >
        <Box
          sx={{
            width: 140,
            height: 140,
            borderRadius: "50%",
            background: "#FFF6CC",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img src={couponicon} />
        </Box>

        <Typography sx={{ mt: 2, color: "#999" }}>
          No Coupon Available
        </Typography>
      </Box>
    }
    </Box>
    </Box>
    </>
  );
};

export default CouponsList;
